export default __webpack_public_path__ + "static/media/py.c3f4c84c.svg";